import downArrow from './assets/24h.png'
import herol2c1 from './assets/hero-2-1.png'
import herol1c2 from './assets/hero-1-2.png'
import herol1c2Mobile from './assets/hero-mobile.png'

const Hero = () => {

    const scrollTo = (id) => {
        document.getElementById(id).scrollIntoView({ 
            behavior: 'smooth',
            block: 'center'
        });
    }

    return ( 
        <div className="hero">
            <div className="first-column">
                <div className='title'>Sua vida <div className='span-blue-background'>não</div> é um jogo</div>
                <img className='smiling-man' src={herol2c1} alt="" />
                {/* <img className='star-background' src={star} alt="" /> */}
                {/* <img className='star-background-mobile' src={starMobile} alt="" /> */}
            </div>
            <div className="second-column">
                <div className="second-line">
                    <div className="hero-texts">
                        <h4>Cuidamos de quem joga</h4>
                        <span className='underlined'>Estamos aqui 24 horas por dia para atender quem mais precisa.</span>
                        <span>Nosso compromisso é com a saúde mental dos jogadores e suas famílias. Somos especialistas em identificar os impactos do vício em apostas esportivas, ajudando você a retomar o controle da sua vida.</span>
                    </div>
                    <img src={downArrow} onClick={() => scrollTo('apoio')} className="scroll-button" alt=''/>
                </div>
                <img className='praying-man' src={herol1c2} alt="" />
                <img className='praying-man-mobile' src={herol1c2Mobile} alt="" />
            </div>
        </div>
     );
}
 
export default Hero;